import React from 'react';
import { displayName } from '../../../App';
import MainGuidanceLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/Profile/AuthorizedViewers';

function AuthorizedViewers() {
  document.title = `${displayName}: Authorized Viewers`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default AuthorizedViewers;
